<template>
  <div id="checkout-login" class="coupon-content">
                <div class="coupon-info">
                  <p class="coupon-text">Quisque gravida turpis sit amet nulla posuere lacinia. Cras sed est
                    sit amet ipsum luctus.</p>
                  <form action="javascript:void(0)">
                    <p class="form-row-first">
                      <label>Username or email <span class="required">*</span></label>
                      <input type="text">
                    </p>
                    <p class="form-row-last">
                      <label>Password <span class="required">*</span></label>
                      <input type="text">
                    </p>
                    <p class="form-row">
                      <input value="Login" type="submit">
                      <label>
                        <input type="checkbox">
                        Remember me
                      </label>
                    </p>
                    <p class="lost-password"><a href="javascript:void(0)">Lost your password?</a></p>
                  </form>
                </div>
              </div>
</template>

<script>
export default {
  name: "CheckoutLogin",
}
</script>

<style>

</style>
